import * as Sentry from '@sentry/vue';

const FR_DIALOG_OPTIONS = {
    lang: 'fr',
    title: 'Une erreur est survenue',
    subtitle: 'Notre équipe a été notifiée.',
    subtitle2:
        'Si vous souhaitez nous aider, décrivez ce que vous étiez en train de faire.',
    labelName: 'Nom',
    labelEmail: 'E-mail',
    labelComments: "Que s'est-il passé ?",
    labelClose: 'Fermer',
    labelSubmit: 'Envoyer le rapport',
    successMessage: 'Merci pour votre retour !',
} as const;

export function useSentryFeedback() {
    /**
     * Opens the Sentry feedback form (for spontaneous user-initiated reports).
     * Requires feedbackIntegration({ autoInject: false }) to be registered in Sentry.init.
     */
    const openFeedbackForm = async (): Promise<void> => {
        const feedback = Sentry.getFeedback();

        if (!feedback) {
            return;
        }

        const form = await feedback.createForm();
        form.appendToDom();
        form.open();
    };

    /**
     * Opens the Sentry crash-report dialog tied to a specific event id.
     * Call this when a server-side error event was already captured and its
     * event id was forwarded to the frontend (e.g. from Error.vue).
     */
    const openCrashReport = (eventId: string): void => {
        Sentry.showReportDialog({
            eventId,
            ...FR_DIALOG_OPTIONS,
        });
    };

    return { openFeedbackForm, openCrashReport };
}
